import {ContainerBinder} from '../../IoC/ContainerBinder';
import {ApiCollectionState} from './api/ApiCollectionState';
import {ApiCollectionStateJrpc} from './api/ApiCollectionState.jrpc';
import {CachedMediaDbService} from './cachedMediaDB/CachedMediaDb.service';
import {CurrentUserService} from './currentUser/CurrentUser.service';
import {CurrentUserServiceJrpc} from './currentUser/jrpc/CurrentUser.service.jrpc';
import {DraftMessageService} from './DraftMessage.service';
import {EnvProviderService} from './env/EnvProvider.service';
import {EnvProviderImplService} from './env/EnvProviderImpl.service';
import {FileConvertWsService} from './fileConvertWs/FileConvertWs.service';
import {FileConvertWsServiceJrpc} from './fileConvertWs/jrpc/FileConfertWs.service.jrpc';
import {LocalStorageService} from './LocalStorage.service';
import {ModalService} from './modalService/Modal.service';
import {ModelsRegistry} from './modelsRegistry/ModelsRegistry';
import {PendingPostsService} from './pendingPosts/PendingPosts.service';
import {RemoteFileStorageService} from './remoteFileStorage/RemoteFileStorage.service';
import {CoreServiceLocator} from './serviceLocator/CoreServiceLocator';
import {ThemeProviderService} from './themeProvider/ThemeProvider.service';

export const bindSystemCommon = (container: ContainerBinder.Container) => {
  return new ContainerBinder(container)
    .bindSingleton(CoreServiceLocator, null, {
      onActivation: (_context, serviceLocator) => {
        serviceLocator.setContainer(container);

        return serviceLocator;
      },
    })
    .bindSingleton(ModelsRegistry)
    .bindSingleton(CurrentUserService, CurrentUserServiceJrpc)
    .bindSingleton(EnvProviderService, EnvProviderImplService)
    .bindSingleton(FileConvertWsService, FileConvertWsServiceJrpc)
    .bindSingleton(CachedMediaDbService)
    .bindSingleton(RemoteFileStorageService)
    .bindSingleton(LocalStorageService)
    .bindSingleton(DraftMessageService)
    .bindSingleton(PendingPostsService)
    .bindSingleton(ThemeProviderService)
    .bindSingleton(ModalService)
    .bind(ApiCollectionState, ApiCollectionStateJrpc)
    .done();
};
